import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 11 28"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M.03 11.55v7.584h1.81v8.854h.948V17.222c-1.166 0-.948-.211-.948.972H.987V11.09a3.3 3.3 0 0 1 .295-1.266c.18-.398.438-.753.757-1.045 1.087-1.076 2.775-.86 4.425-.86a3.23 3.23 0 0 1 1.871.393c.573.317 1.04.801 1.346 1.39.216.43.337.904.354 1.388v7.104h-.853c0-1.196.205-.972-.949-.972v10.766h.949v-8.854h1.81V11.55a4.4 4.4 0 0 0-.539-2.383 4.25 4.25 0 0 0-1.717-1.698 3.6 3.6 0 0 0-1.688-.453h-3.09a4 4 0 0 0-2.209.772A4.16 4.16 0 0 0 .317 9.677 5.2 5.2 0 0 0 0 11.55zm3.252-8.092a2.26 2.26 0 0 1 .723-1.883 2.21 2.21 0 0 1 2.799-.206c.421.295.731.728.881 1.228s.13 1.036-.056 1.523a2.3 2.3 0 0 1-.969 1.156 2.2 2.2 0 0 1-1.46.285 2.24 2.24 0 0 1-1.316-.708 2.34 2.34 0 0 1-.6-1.395zM5.345.016h.317A3.1 3.1 0 0 1 7.4.638c.085.069.344.289.401.354s.13.165.19.243a3.34 3.34 0 0 1-.033 4.142 3.125 3.125 0 0 1-4.2.633 3.25 3.25 0 0 1-1.062-1.197 3.34 3.34 0 0 1-.375-1.572 2.94 2.94 0 0 1 .284-1.296c.3-.708.838-1.283 1.514-1.62.384-.192.8-.302 1.226-.325z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.038 27.997h.948v-8.854h-.948z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }